import React, { useEffect, useState } from "react";
import { trackEvent } from "@leafly-com/web-utils";
import { useInView } from "react-intersection-observer";
import { useSelector } from "react-redux";

import getFeaturedDeals from "api/requests/getFeaturedDeals";
import { Deal } from "custom-types/Deals";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import { getCoordinates } from "redux/selectors/location";

import CarouselPlaceholder from "components/botanic/Carousel/CarouselPlaceholder";

import DealsSection from "./DealsSection";

type Props = {
  page: string;
  title: string;
};

const Deals = ({ page, title }: Props): JSX.Element => {
  const countryCode = useDomainCountryCode();
  const coordinates = useSelector(getCoordinates);

  const [deals, setDeals] = useState<Deal[]>([]);
  const [dealsLoading, setDealsLoading] = useState(true);
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const getDeals = async () => {
    const { deals } = await getFeaturedDeals(coordinates, countryCode);

    setDealsLoading(false);
    setDeals(deals);
  };

  useEffect(() => {
    if (inView) {
      getDeals();
    }
    return () => {
      trackEvent("Carousel", "Impression", "Loaded");
    };
  }, [coordinates, countryCode, inView]);

  return (
    <div ref={ref}>
      {dealsLoading && <CarouselPlaceholder />}
      {!dealsLoading && deals.length > 0 ? (
        <DealsSection deals={deals} page={page} title={title} />
      ) : null}
    </div>
  );
};

export default Deals;
